export const travellerBenefits = [
  "Up to 50% off dining at Accor hotels and resorts ",
  "Exclusive member-only offers and discounts",
  "10% off the best available rates on accommodation",
  "Access to VIP exclusive events and experiences",
  "Get immediate Elite ALL status and 20 Status Nights",
];

export const explorerBenefits = [
  "Complimentary night stay at participating hotels ",
];

export const discoveryBenefits = [
  "Complimentary night stay at participating hotels ",
];
